import React from "react";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
interface IReviewTableProps {
    data: any[];
}

export const ReviewTable = (props: IReviewTableProps) => {
    return (
        // <div className="table-scrollable">
        <div>
            <table className="table-subtle table-first-last-cell-padding-reset">
                <thead>
                    <tr>
                        <th>Arangement ID</th>
                        <th className="cell-right">GAD maximum</th>
                        <th>Pension year start date</th>
                        <th>Reference period end date</th>
                        <th className="cell-right">Remaining GAD maximum</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data &&
                        props.data.length > 0 &&
                        props.data.map((row, index) => {
                            return (
                                <tr key={index}>
                                    <td>{row.ArrangementId}</td>
                                    <td className="cell-right">{row.GadMaximum}</td>
                                    <td>{JsonDateParser.getFormatDate(row.PensionYearStart, "dd/MM/yyyy")}</td>
                                    <td>{JsonDateParser.getFormatDate(row.ReferencePeriodEndDate, "dd/MM/yyyy")}</td>
                                    <td className="cell-right">{row.GadMaximum - row.IncomeTakenInCurrentYear.Amount}</td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
};
